import RootRequest from "./RootRequest";

export default class BnrApiRequest extends RootRequest {
  get apiResource() {
    return "api/bnr-api";
  }

  async getCurrentEurRonExchangeRate() {
    const response = await this.makeRequest(
      RootRequest.METHOD.GET,
      this.apiRoutes.FIND_ALL
    );

    return response?.data;
  }
}

export const bnrApiRequest = new BnrApiRequest();
